import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Customer, get } from '../../../../api';
import type { UploadFile } from 'antd/es/upload/interface';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { useUser } from '../../../../hooks';
import moment from 'moment';
import { CanShow } from '../../../../components';
import {
  OrderCustomer,
  CreateOrderCustomer,
  UpdateOrderCustomer,
} from '../../../../api/models/orders';
type OrderFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateOrderCustomer) => void;
  update: (v: UpdateOrderCustomer) => void;
};

const BackOrderForm: React.FC<OrderFormProps> = (props) => {
  const { type, id, add, update } = props;
  const [form] = Form.useForm();
  const { user } = useUser();
  const { isLoading: isLoadingData, data } = useQuery<OrderCustomer>(
    [type],
    () => get<OrderCustomer>('/orders/' + id).then((e) => e.data)
  );
  const { isLoading: isLoadingParts, data: parts } = useQuery<Customer[]>(
    ['parts'],
    () => get<Customer[]>('/parts').then((e) => e.data)
  );
  const { isLoading: isLoadingCustomers, data: customers } = useQuery<
    Customer[]
  >(['customers'], () => get<Customer[]>('/customers').then((e) => e.data));

  useEffect(() => {
    if (type !== 'add' && id && data) {
      form.setFieldsValue({
        part_id: data.part_id,
        quantity: data.quantity,
        pending_shipment: data.pending_shipment,
        customer_id: data.customer_id,
      });
    }
    // setIsLoading(false);
  }, [form, data, id, type]);

  const fileList: UploadFile[] = [
    {
      uid: '-1',
      name: 'yyy.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      thumbUrl:
        'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
  ];
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf('day');
  };
  const addContractFunction = async (values: any) => {
    if (type === 'add' && user) {
      // AGREGAR ORDEN
      let contractRequest: CreateOrderCustomer = {
        customer_id: values.customer_id,
        part_id: values.part_id,
        // customer_id: user.extendedInfo ? user.extendedInfo.id : values.customer,
        quantity: values.quantity,
      };
      add(contractRequest);
    } else {
      // EDITAR ORDEN
      if (!id) return;
      values['id'] = id;
      update(values);
    }
  };

  return (
    <Spin
      spinning={isLoadingData || isLoadingCustomers}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="contracts"
        layout="vertical"
        form={form}
        onFinish={addContractFunction}
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            <Row gutter={16}>
              <CanShow roles={['Admin', 'Financial']}>
                <Col xs={24} md={16}>
                  {customers && (
                    <Form.Item
                      label="Cliente:"
                      name="customer_id"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor seleccione cliente',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Selecciona una opción"
                        disabled={type !== 'add'}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {customers.map((e: any) => (
                          <Select.Option key={e.id} value={e.id}>
                            {e.company_name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
              </CanShow>
              {type !== 'add' && (
                <Col xs={24} md={8}>
                  <Form.Item
                    label="Pendiente de envío:"
                    name="pending_shipment"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor ingrese cantidad',
                      },
                    ]}
                  >
                    <InputNumber
                      disabled={type === 'watch'}
                      style={{ width: '100%' }}
                      placeholder="Ingresa información"
                    />
                  </Form.Item>
                </Col>
              )}
              <Col xs={24} md={16}>
                {parts && (
                  <Form.Item
                    label="Parte:"
                    name="part_id"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione parte',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      // disabled={type !== 'add'}
                      disabled={type === 'watch'}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {parts.map((e: any) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.description}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Cantidad:"
                  name="quantity"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese cantidad',
                    },
                  ]}
                >
                  <InputNumber
                    disabled={type === 'watch'}
                    style={{ width: '100%' }}
                    placeholder="Ingresa información"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === 'watch' || isLoadingData}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default BackOrderForm;
